import VerificationReminder from './VerificationReminder';
import VerificationReminderContainer from './VerificationReminder.container';
export default VerificationReminderContainer(VerificationReminder);

//# sourceMappingURL=index.js.map